// extracted by mini-css-extract-plugin
export default {"asciiContainer":"AsciiDonut_asciiContainer__E1wos","asciiDonut":"AsciiDonut_asciiDonut__lTqQj","light":"AsciiDonut_light__jYpoC"};